"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { CoinbaseWalletAdapter } from "@solana/wallet-adapter-coinbase";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { useMemo } from "react";
export const SolanaWalletProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    getRpcUrls
  } = useChains();
  let t1;
  if ($[0] !== getRpcUrls) {
    const rpcUrls = getRpcUrls("solana");
    t1 = rpcUrls.at(0) ?? DEFAULT_SOLANA_RPC_URL;
    $[0] = getRpcUrls;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rpcUrl = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [new CoinbaseWalletAdapter()];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  t2 = t3;
  const wallets = t2;
  let t4;
  if ($[3] !== children) {
    t4 = <WalletProvider autoConnect={true} wallets={wallets}>{children}</WalletProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== rpcUrl || $[6] !== t4) {
    t5 = <ConnectionProvider endpoint={rpcUrl}>{t4}</ConnectionProvider>;
    $[5] = rpcUrl;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
const DEFAULT_SOLANA_RPC_URL = "https://api.mainnet-beta.solana.com";